import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SortOptionsService {
  constructor() {}

  sortList(list: any[], sortBy?: string) {
    if(list?.length > 0) {  
      list?.sort(function(a, b){  
        var nameA = a, nameB = b;
        if ((sortBy && nameA[sortBy] < nameB[sortBy]) || nameA < nameB) { //sort string ascending
          return -1;
        } 
        if ((sortBy && nameA[sortBy] > nameB[sortBy]) || nameA > nameB) {
          return 1;
        } 
        return 0; //default return value (no sorting)
      });
    }  
    return list;
  }
}